export default __webpack_public_path__ + "static/media/angeles-hosp.6724f240.png";